// extracted by mini-css-extract-plugin
export default {"rating":"fL-z","numberOfStars":"gL-z","count":"hL-z","barGraphSpacing":"iL-z","barGraph":"jL-z"};